import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, toJS } from 'mobx';
import Modal from '../../Modal';
import Form, { FormBody, FormActions, TextInput, SwitchInput } from '../../Form';
import FormMultiSelectInput from '../../FormMultiSelectInput';

@inject('rawDataExportStore', 'dataSourceStore', 'parameterStore')
@observer
class RawDataExportModify extends Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  }

  @observable editMode = false;
  @observable item = {
    name: '',
    url: '',
    raw_data_id: 0,
    raw_data_end: 0,
    status: 1,
    origins: [],
    parameters: [],
  };

  @observable multiStationOptions = [];
  @observable multiParameterOptions = [];

  slug = '/export/raw-data-export';
  title = '';

  componentWillMount() {
    const { params: { id }, dataSourceStore, parameterStore } = this.props;

    if (!dataSourceStore.items.length && !dataSourceStore.isLoading) dataSourceStore.fetchItems();
    if (!parameterStore.items.length && !parameterStore.isLoading) parameterStore.fetchItems();

    this.editMode = id !== 'add';
    if (this.editMode) {
      this.title = 'Edit Raw Data Export';
      this.reset();
    } else this.title = 'Add Raw Data Export';
    this.populateOptions();
  }

  @action reset = () => {
    const { params: { id }, rawDataExportStore } = this.props;
    const foundItem = rawDataExportStore.findById(id);
    if (foundItem) {
      this.item = foundItem.asJson;
    }
  }

  populateOptions = () => {
    const { dataSourceStore, parameterStore } = this.props;
    if (dataSourceStore.items.length === 0 || parameterStore.items.length === 0) {
      setTimeout(() => {
        this.populateOptions();
      }, 300)
    } else {
      let multiStationOptions = [];
      let item = toJS(this.item)
      dataSourceStore.items.forEach(ds => {
        ds.origins.forEach(origin => {
          let station = !origin.stations || !origin.stations.length ? '' : ` - ${origin.stations[0].name}`;
          multiStationOptions.push({ id: origin.id, source: ds.name, name: origin.code, label: origin.code.toString() + station, station, value: !!this.item.origins && !!this.item.origins.find(i => +i.id === +origin.id) });
        })
      });
      this.multiStationOptions = multiStationOptions;
      this.multiParameterOptions = parameterStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, value: !!this.item.parameters && !!this.item.parameters.find(i => +i.id === +item.id), code: item.code }));
    }
  };

  @action onChange = (e, field) => this.item[field] = e.target.value;
  @action onOptionClicked = item => item.value = !item.value;

  filterOriginOptions = (origins, filterText) => {
    return origins.filter(origin => (
      (origin &&
        origin.label &&
        origin.label.toLowerCase().indexOf(filterText) > -1) ||

      (origin &&
        origin.source &&
        origin.source.toLowerCase().indexOf(filterText) > -1)
    ))
  }

  optionsReducer = options => options.reduce((acc, item) => {
    if (item.value === true) acc.push({ id: item.id });
    return acc;
  }, []);

  handleSave = (e) => {
    e.preventDefault();

    const { rawDataExportStore } = this.props;
    const { notify, router } = this.context;

    let payload = Object.assign({}, toJS(this.item), {
      origins: this.optionsReducer(this.multiStationOptions),
      parameters: this.optionsReducer(this.multiParameterOptions),
    });

    (this.editMode ? rawDataExportStore.updateItem(payload) : rawDataExportStore.createItem(payload))
      .then(() => {
        notify.success({ message: 'Success' });
        router.push(this.slug);
      })
      .catch(err => {
        notify.error(err);
      });
  }

  render() {
    const { rawDataExportStore, dataSourceStore, parameterStore } = this.props;
    // console.log(toJS(dataSourceStore.items));
    // console.log(toJS(this.multiStationOptions));

    return (
      <Modal title={this.title} slug={this.slug} isLoading={rawDataExportStore.isLoading || dataSourceStore.isLoading || parameterStore.isLoading} isSaving={rawDataExportStore.isSaving} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            <TextInput label={'Name'} value={this.item.name} onChange={e => this.onChange(e, 'name')} />
            <TextInput label={'Url'} value={this.item.url} onChange={e => this.onChange(e, 'url')} />
            <TextInput label={'Raw Data From'} value={this.item.raw_data_id} onChange={e => this.onChange(e, 'raw_data_id')} />
            <TextInput label={'Raw Data To'} value={this.item.raw_data_end} onChange={e => this.onChange(e, 'raw_data_end')} />
            <SwitchInput label={'Enabled'} value={!!+this.item.status} onChange={e => this.item.status = ~this.item.status + 2} />

            <FormMultiSelectInput id='station-multi-select' label='Origins' options={this.multiStationOptions} optionClicked={this.onOptionClicked} isLoading={dataSourceStore.isLoading} filterOptions={this.filterOriginOptions} />
            {/* <FormMultiSelectInput id='parameter-multi-select' label='Parameters' options={this.multiParameterOptions} optionClicked={this.onOptionClicked} isLoading={parameterStore.isLoading} filterOptions={parameterStore.filterParameters} /> */}
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default RawDataExportModify;



// WEBPACK FOOTER //
// ./src/components/DataDelivery/RawDataExport/RawDataExportModify.js